import { RefObject } from "react";
import { Text } from "@amzn/meridian";
import { usePinchZoom } from "../hooks/usePinchZoom";
import "./PinchZoomController.scss";

type PinchZoomControllerProps = {
  videoRef: RefObject<HTMLVideoElement>;
  /** Transparent overlay that receives the pinch touches (sits above the video). */
  gestureTargetRef: RefObject<HTMLElement>;
  /** True once the camera stream is attached; gates zoom-capability detection. */
  streamReady: boolean;
};

/**
 * Renders a live zoom-level indicator while pinch-zoomed in. The pinch gesture
 * and sensor-zoom logic live in usePinchZoom; this renders nothing if the
 * device doesn't support zoom or the user hasn't zoomed in.
 */
const PinchZoomController = ({ videoRef, gestureTargetRef, streamReady }: PinchZoomControllerProps) => {
  const { zoomSupported, zoomLevel } = usePinchZoom(videoRef, gestureTargetRef, streamReady);

  if (!zoomSupported || zoomLevel <= 1.01) {
    return null;
  }

  return (
    <div className="pinch-zoom-indicator" aria-hidden="true">
      <Text color="inverted" type="b200">
        {zoomLevel.toFixed(1)}x
      </Text>
    </div>
  );
};

export default PinchZoomController;
